export enum ProjectType {
    Standard = 0,
    Static = 1,
    Cloud = 2
}
